import { render, staticRenderFns } from "./marketActivityDetail.vue?vue&type=template&id=ec76434a&scoped=true"
import script from "./marketActivityDetail.vue?vue&type=script&lang=js"
export * from "./marketActivityDetail.vue?vue&type=script&lang=js"
import style0 from "./marketActivityDetail.vue?vue&type=style&index=0&id=ec76434a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec76434a",
  null
  
)

export default component.exports